var _a;
import { waitUntil } from '../common';
import consoleEvents from '../consoleEvents';
import { IS_CLIENT } from '../constants';
import { getLocale, getMarket } from '../locale';
import request from '../request';
import { getTouchpoint } from '../touchpoint';
const device = IS_CLIENT && ((_a = window === null || window === void 0 ? void 0 : window.hm) === null || _a === void 0 ? void 0 : _a.device);
const isApp = IS_CLIENT && (device === null || device === void 0 ? void 0 : device.app());
const isIOS = IS_CLIENT && ((device === null || device === void 0 ? void 0 : device.iPhone()) || (device === null || device === void 0 ? void 0 : device.iPad()));
const isAndroid = IS_CLIENT && (device === null || device === void 0 ? void 0 : device.android());
const getIsUtagMethodAvailable = (method) => { var _a; return IS_CLIENT && typeof ((_a = window === null || window === void 0 ? void 0 : window.utag) === null || _a === void 0 ? void 0 : _a[method]) === 'function'; };
const invokeAndroidEvent = (data) => {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.NativeTracker) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify(data));
};
const invokeIOSEvent = (data) => {
    var _a, _b, _c;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.NativeTracker) === null || _c === void 0 ? void 0 : _c.postMessage(data);
};
const invokeUTAGMethod = ({ method, data, isAsync }) => {
    var _a;
    if (!IS_CLIENT)
        return;
    if (!isAsync && getIsUtagMethodAvailable(method)) {
        (_a = window.utag) === null || _a === void 0 ? void 0 : _a[method](data);
    }
    else {
        waitUntil(() => getIsUtagMethodAvailable(method))
            .then(() => {
            var _a;
            (_a = window === null || window === void 0 ? void 0 : window.utag) === null || _a === void 0 ? void 0 : _a[method](data);
        })
            .catch((error) => consoleEvents.error(`utag method: ${method} is not available`, error));
    }
};
const pageTrackingData = {};
const trackingHelper = ({ method, data, isAsync, isHmDefaults = true }) => {
    var _a;
    const getAttribute = (attribute) => { var _a; return (data === null || data === void 0 ? void 0 : data[attribute]) || (pageTrackingData === null || pageTrackingData === void 0 ? void 0 : pageTrackingData[attribute]) || ((_a = window.utag_data) === null || _a === void 0 ? void 0 : _a[attribute]) || ''; };
    const trackingData = isHmDefaults
        ? Object.assign({ category_id: getAttribute('category_id'), category_path: getAttribute('category_path') || getAttribute('categoryPath'), page_id: getAttribute('page_id'), selected_market: getMarket(), display_language: getLocale('upperCase'), touchpoint: getTouchpoint() }, data) : Object.assign({}, data);
    const getIsNativeTrackerAvailable = () => {
        var _a, _b, _c, _d;
        return !!((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.NativeTracker) === null || _c === void 0 ? void 0 : _c.postMessage) ||
            !!((_d = window === null || window === void 0 ? void 0 : window.NativeTracker) === null || _d === void 0 ? void 0 : _d.postMessage);
    };
    const options = IS_CLIENT && ((_a = window === null || window === void 0 ? void 0 : window.hm) === null || _a === void 0 ? void 0 : _a.options);
    const shouldForceUtagLogic = (isIOS && (options === null || options === void 0 ? void 0 : options.forceUtagForIOS)) || (isAndroid && (options === null || options === void 0 ? void 0 : options.forceUtagForAndroid));
    if (isApp && !shouldForceUtagLogic) {
        waitUntil(getIsNativeTrackerAvailable)
            .then(() => {
            const postData = {
                type: method,
                payload: trackingData,
            };
            if (isAndroid) {
                invokeAndroidEvent(postData);
            }
            else if (isIOS) {
                invokeIOSEvent(postData);
            }
        })
            .catch(() => invokeUTAGMethod({ method, data: trackingData, isAsync }));
    }
    else {
        invokeUTAGMethod({ method, data: trackingData, isAsync });
    }
};
export const trackViewEvent = (data, isAsync, isHmDefaults = true) => {
    trackingHelper({
        method: 'view',
        isAsync,
        data,
        isHmDefaults,
    });
    if (isHmDefaults) {
        pageTrackingData.page_id = data.page_id;
        pageTrackingData.category_id = data.category_id;
        pageTrackingData.category_path = data.category_path || data.categoryPath;
    }
};
export const trackEvent = (data, isAsync, isHmDefaults = true) => {
    trackingHelper({
        method: isApp ? 'event' : 'link',
        data,
        isAsync,
        isHmDefaults,
    });
};
export const trackESalesEvent = ({ url, data }) => {
    request.post(url, { use: { apiVersion: false }, data });
};
//# sourceMappingURL=trackingUtils.js.map